import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import DialedDigitExtractionServerList from './containers/DialedDigitExtractionServerList';
import DialedDigitExtractionServerCreate from './containers/DialedDigitExtractionServerCreate';
import DialedDigitExtractionServerEdit from './containers/DialedDigitExtractionServerEdit';
import DialedDigitExtractionServerView from './containers/DialedDigitExtractionServerView';
import { SYSTEM_CONFIGURATION_ROUTE, DIALED_DIGIT_EXTRACTION_SERVER_ROUTE, SYSTEM } from '../../constants';

interface Props {
}

const DialedDigitExtractionServer: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${DIALED_DIGIT_EXTRACTION_SERVER_ROUTE}`}>
        <DialedDigitExtractionServerList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${DIALED_DIGIT_EXTRACTION_SERVER_ROUTE}/create`}>
        <DialedDigitExtractionServerCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${DIALED_DIGIT_EXTRACTION_SERVER_ROUTE}/edit`}>
        <DialedDigitExtractionServerEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${DIALED_DIGIT_EXTRACTION_SERVER_ROUTE}/view`}>
        <DialedDigitExtractionServerView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default DialedDigitExtractionServer;
